module.exports = window["Bernie_l10nBundle_pl_PL"];